import SHOrgPicker from './src/picker.vue';

/* istanbul ignore next */
SHOrgPicker.install = function(Vue) {
  Vue.component('sh-org-picker', SHOrgPicker);
};

export default SHOrgPicker;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/org/picker/index.js